import { useSearch } from "@tanstack/react-router";
import { useGetIntegrationQuery } from "api/TenantSlug/Integration/hooks";
import { ModifyIntegrationForm } from "components/Forms/ModifyIntegrationForm/ModifyIntegrationForm";
import { Drawer } from "components/UI/Drawer";
import { useDrawer } from "hooks/useDrawer";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

import { DrawerTitle } from "../../UI/DrawerTitle/DrawerTitle.tsx";

interface SearchParams {
    [`modifyIntegration-id`]: string;
}

export const ModifyIntegrationDrawer: FC = () => {
    const { t } = usePaldockTranslation("drawers.modify-integration");
    const drawerId = DrawerId.ModifyIntegration;
    const drawerUtils = useDrawer();

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const integrationId = searchParams[`${drawerId}-id`];
    const getIntegrationQuery = useGetIntegrationQuery(integrationId);

    if (getIntegrationQuery.isLoading || getIntegrationQuery.isFetching || !getIntegrationQuery.data?.integration) {
        return <></>;
    }
    const integration = getIntegrationQuery.data.integration;

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title")} subTitles={[integration.name]} />}
            searchParamsToClean={[`${drawerId}-id`]}
        >
            <ModifyIntegrationForm onClose={() => drawerUtils.hide(drawerId)} integration={integration} />
        </Drawer>
    );
};
